import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import { createMuiTheme, Divider, FormControlLabel, Grid, MuiThemeProvider, Switch, Button, CircularProgress, withTheme, Tooltip, Typography, StepButton, Avatar, List, ListItem, ListItemIcon, ListItemText, Fade, Snackbar, withWidth } from '@material-ui/core';
import { mergeDeepLeft, cond, equals } from 'ramda';
import React__default, { createElement, Component, Fragment } from 'react';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _extends from '@babel/runtime/helpers/esm/extends';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { css } from 'emotion';
import { pure, compose } from 'recompose';
import { faSave, faCircle } from '@fortawesome/pro-solid-svg-icons';
import green from '@material-ui/core/colors/green';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import cn from 'classnames';
import { ErrorTemplate, I18nMessage, addDelayToLoadingProp } from '@apoly-42/apoly-components';
import { defineMessages } from 'react-intl';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread';
import { connectionAborted, getErrorFromProp, withPropOnChange } from '@apoly-42/apoly-utils';
import Loadable from 'react-loadable';
import { Link } from 'react-router-dom';
import { isWidthDown } from '@material-ui/core/withWidth';

var createAppMuiTheme = function createAppMuiTheme(themeOptions) {
  return createMuiTheme(mergeDeepLeft(themeOptions || {}, {
    palette: {
      type: themeOptions.type
    },
    body1: {
      margin: '0px;'
    }
  }));
};
var AppMuiThemeDecorator =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AppMuiThemeDecorator, _React$Component);

  function AppMuiThemeDecorator() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AppMuiThemeDecorator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AppMuiThemeDecorator)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      darkThemeSelected: true
    };

    _this.setDarkThemeSelected = function () {
      _this.setState({
        darkThemeSelected: !_this.state.darkThemeSelected
      });
    };

    return _this;
  }

  _createClass(AppMuiThemeDecorator, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return createElement(MuiThemeProvider, {
        theme: createAppMuiTheme({
          type: this.state.darkThemeSelected ? 'dark' : 'light'
        })
      }, createElement("div", {
        style: {
          height: 'calc(100vh - 40px)',
          backgroundColor: this.state.darkThemeSelected ? '#37474F' : '#fafafa',
          padding: 16,
          margin: -8
        }
      }, createElement(Grid, {
        container: true
      }, createElement(Grid, {
        item: true,
        xs: 12
      }, createElement(FormControlLabel, {
        control: createElement(Switch, {
          color: "primary",
          checked: this.state.darkThemeSelected,
          onChange: function onChange() {
            return _this2.setDarkThemeSelected();
          }
        }),
        label: "switch theme"
      })), createElement(Grid, {
        item: true,
        xs: 12
      }, createElement(Divider, {
        style: {
          height: 4
        }
      })), createElement(Grid, {
        item: true,
        xs: 12
      }, this.props.children))));
    }
  }]);

  return AppMuiThemeDecorator;
}(Component);

// mittig positionieren deswegen nur höhe 100% beim einen
var ButtonWithIcon = function ButtonWithIcon(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      _ref$iconRight = _ref.iconRight,
      iconRight = _ref$iconRight === void 0 ? false : _ref$iconRight,
      _ref$iconFontSize = _ref.iconFontSize,
      iconFontSize = _ref$iconFontSize === void 0 ? 16 : _ref$iconFontSize,
      props = _objectWithoutProperties(_ref, ["children", "icon", "iconRight", "iconFontSize"]);

  return React__default.createElement(Button, props, React__default.createElement("span", {
    style: {
      display: 'flex',
      height: '100%',
      width: '100%'
    }
  }, React__default.createElement("span", {
    style: {
      margin: 'auto',
      display: 'flex',
      height: '100%'
    }
  }, !iconRight && React__default.createElement(FontAwesomeIcon, {
    icon: icon,
    style: {
      margin: 'auto 4px',
      fontSize: iconFontSize
    }
  }), React__default.createElement("span", {
    style: {
      margin: 'auto 4px'
    }
  }, children), iconRight && React__default.createElement(FontAwesomeIcon, {
    icon: icon,
    style: {
      margin: 'auto 4px',
      fontSize: iconFontSize
    }
  }))));
};

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -12px;\n  margin-left: -12px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var btnProgressClass = function btnProgressClass(theme) {
  return css(_templateObject(), theme.palette.primary.main);
};

// see https://material-ui-next.com/demos/progress/#interactive-integration
var InnerSavingButton = function InnerSavingButton(_ref) {
  var children = _ref.children,
      _ref$saving = _ref.saving,
      saving = _ref$saving === void 0 ? false : _ref$saving,
      _ref$containerClassNa = _ref.containerClassName,
      containerClassName = _ref$containerClassNa === void 0 ? '' : _ref$containerClassNa,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["children", "saving", "containerClassName", "disabled", "theme"]);

  return React__default.createElement("div", {
    className: containerClassName,
    style: {
      position: 'relative',
      width: 'fit-content'
    }
  }, React__default.createElement(Button, _extends({
    variant: "raised",
    color: "primary",
    disabled: saving || disabled
  }, props), children), saving && React__default.createElement(CircularProgress, {
    size: 24,
    className: btnProgressClass(theme)
  }));
};

var SavingButton = pure(withTheme()(InnerSavingButton));

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  min-height: ", ";\n  line-height: 32px;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var tooltipClass = function tooltipClass(theme) {
  return css(_templateObject$1(), theme.typography.pxToRem(14), theme.spacing.unit * 4);
};

var InnerCustomTooltip = function InnerCustomTooltip(_ref) {
  var theme = _ref.theme,
      title = _ref.title,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["theme", "title", "children"]);

  return React__default.createElement(Tooltip, _extends({
    title: title,
    classes: {
      tooltip: tooltipClass(theme)
    }
  }, props), children);
};

var CustomTooltip = withTheme()(InnerCustomTooltip);

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: ", "px;\n  right: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  position: absolute;\n  top: -4px;\n  left: -4px;\n  z-index: 1;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var fabProgress = css(_templateObject$2(), green[500]);

var fixed = function fixed(theme) {
  return css(_templateObject2(), theme.spacing.unit * 2, theme.spacing.unit * 2);
};

// div 1: fixed: position for Button: and visible onScroll
// div 2: needs position relative so that the circularProgress position is relative to the fab button
// tooltip for better understanding since this button just contains an icon
var InnerSavingIconButton = function InnerSavingIconButton(_ref) {
  var theme = _ref.theme,
      tooltipTitle = _ref.tooltipTitle,
      _ref$saving = _ref.saving,
      saving = _ref$saving === void 0 ? false : _ref$saving,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? faSave : _ref$icon,
      _ref$toolTipProps = _ref.toolTipProps,
      toolTipProps = _ref$toolTipProps === void 0 ? {} : _ref$toolTipProps,
      props = _objectWithoutProperties(_ref, ["theme", "tooltipTitle", "saving", "icon", "toolTipProps"]);

  return React__default.createElement("div", {
    className: fixed(theme)
  }, React__default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, React__default.createElement(CustomTooltip, _extends({
    title: tooltipTitle
  }, toolTipProps), React__default.createElement(Button, _extends({
    variant: "fab",
    color: "primary",
    disabled: saving
  }, props), React__default.createElement(FontAwesomeIcon, {
    icon: icon
  }))), saving && React__default.createElement(CircularProgress, {
    size: 64,
    className: fabProgress
  })));
};

var SavingIconButton = withTheme()(InnerSavingIconButton);

var _Object$create;

function _templateObject2$1() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: ", ";\n    ", " {\n      padding-top: ", ";\n    }\n    ", " {\n      padding-top: ", ";\n    }\n  "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteral(["\n    padding-top: ", ";\n    ", " {\n      padding-top: ", ";\n    }\n    ", " {\n      padding-top: ", ";\n    }\n  "]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var rowTypes = Object.create({
  greatSection: 'greatSection',
  section: 'section',
  paragraph: 'paragraph',
  row: 'row'
});
var spacingUnit = 16;

var calcRowSpace = function calcRowSpace(spaceFactor) {
  return "".concat(spaceFactor * spacingUnit, "px!important");
};

var rowTypeSpacings = Object.create((_Object$create = {}, _defineProperty(_Object$create, rowTypes.greatSection, {
  defaultVal: 4,
  md: 3,
  xs: 2
}), _defineProperty(_Object$create, rowTypes.section, {
  defaultVal: 3
}), _defineProperty(_Object$create, rowTypes.paragraph, {
  defaultVal: 2
}), _defineProperty(_Object$create, rowTypes.row, {
  defaultVal: 1
}), _Object$create));

var getSpacingForMediaQuery = function getSpacingForMediaQuery(mediaQ, type) {
  return rowTypeSpacings[type][mediaQ] || rowTypeSpacings[type].defaultVal;
};

var topSpace = function topSpace(theme, type, noPaddingTop) {
  return !noPaddingTop && css(_templateObject$3(), calcRowSpace(rowTypeSpacings[type].defaultVal), theme.breakpoints.down('md'), calcRowSpace(getSpacingForMediaQuery('md', type)), theme.breakpoints.down('xs'), calcRowSpace(getSpacingForMediaQuery('xs', type)));
};

var bottomSpace = function bottomSpace(theme, type, noPaddingBot) {
  return !noPaddingBot && css(_templateObject2$1(), calcRowSpace(rowTypeSpacings[type].defaultVal), theme.breakpoints.down('md'), calcRowSpace(getSpacingForMediaQuery('xs', type)), theme.breakpoints.down('xs'), calcRowSpace(getSpacingForMediaQuery('xs', type)));
};

var InnerGridRow = function InnerGridRow(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? rowTypes.row : _ref$type,
      _ref$noPaddingTop = _ref.noPaddingTop,
      noPaddingTop = _ref$noPaddingTop === void 0 ? false : _ref$noPaddingTop,
      _ref$noPaddingBottom = _ref.noPaddingBottom,
      noPaddingBottom = _ref$noPaddingBottom === void 0 ? false : _ref$noPaddingBottom,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ["children", "theme", "type", "noPaddingTop", "noPaddingBottom", "className"]);

  return React__default.createElement(Grid, _extends({
    className: cn(className, topSpace(theme, type, noPaddingTop), bottomSpace(theme, type, noPaddingBottom)),
    item: true
  }, props), children);
};

var GridRow = withTheme()(InnerGridRow);

var messages = defineMessages({
  badConnectivity: {
    id: 'badConnectivity',
    defaultMessage: 'It seems that you are not currently connected to the Internet.'
  },
  reloadWhenINet: {
    id: 'reloadWhenINet',
    defaultMessage: 'Try reloading the page when you are connected again.'
  }
});
var ConnectionAborted = function ConnectionAborted() {
  return React__default.createElement(ErrorTemplate, null, React__default.createElement(Grid, {
    container: true,
    spacing: 16
  }, React__default.createElement(GridRow, {
    type: rowTypes.greatSection,
    xs: 12,
    lg: 10
  }, React__default.createElement(Typography, {
    variant: "headline",
    paragraph: true
  }, React__default.createElement(I18nMessage, {
    message: messages.badConnectivity
  })), React__default.createElement(Typography, {
    paragraph: true
  }, React__default.createElement(I18nMessage, {
    message: messages.reloadWhenINet
  })))));
};

var CStepButton = function CStepButton(_ref) {
  var _ref$completedLabel = _ref.completedLabel,
      completedLabel = _ref$completedLabel === void 0 ? null : _ref$completedLabel,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? null : _ref$optional,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? null : _ref$style,
      props = _objectWithoutProperties(_ref, ["completedLabel", "optional", "style"]);

  return React__default.createElement(StepButton, _extends({
    optional: props.completed ? completedLabel : optional,
    style: _objectSpread({
      paddingBottom: 8,
      marginBottom: -8,
      paddingTop: 8,
      marginTop: -8
    }, style)
  }, props));
};
CStepButton.muiName = 'StepButton';

var messages$1 = defineMessages({
  thatShouldNotHaveHappened: {
    id: 'thatShouldNotHaveHappened',
    defaultMessage: 'Sorry, that should not have happened!'
  },
  errorOccurred: {
    id: 'errorOccurred',
    defaultMessage: 'An error occurred.'
  },
  weInvestigateAndTryToSolveProblem: {
    id: 'weInvestigateAndTryToSolveProblem',
    defaultMessage: 'We will investigate this Problem and try to resolve it as fast as possible.'
  },
  sorryForInconveniences: {
    id: 'sorryForInconveniences',
    defaultMessage: 'Please accept our apologies for the inconvenience caused.'
  },
  tryToRefreshPageOnError: {
    id: 'tryToRefreshPageOnError',
    defaultMessage: 'Please try to reload this page. If the problem persists, try again later today or tomorrow.'
  }
});
var UnknownError = function UnknownError() {
  return React__default.createElement(ErrorTemplate, null, React__default.createElement(Grid, {
    container: true,
    spacing: 16
  }, React__default.createElement(GridRow, {
    type: rowTypes.greatSection,
    xs: 12,
    lg: 10
  }, React__default.createElement(Typography, {
    variant: "headline",
    paragraph: true
  }, React__default.createElement(I18nMessage, {
    message: messages$1.thatShouldNotHaveHappened
  })), React__default.createElement(Typography, {
    paragraph: true
  }, React__default.createElement(I18nMessage, {
    message: messages$1.errorOccurred
  })), React__default.createElement(Typography, {
    paragraph: true
  }, React__default.createElement(I18nMessage, {
    message: messages$1.tryToRefreshPageOnError
  })), React__default.createElement(Typography, {
    paragraph: true
  }, React__default.createElement(I18nMessage, {
    message: messages$1.weInvestigateAndTryToSolveProblem
  })), React__default.createElement(Typography, {
    paragraph: true
  }, React__default.createElement(I18nMessage, {
    message: messages$1.sorryForInconveniences
  })))));
};

var getErrorComponent = cond([[connectionAborted, function () {
  return ConnectionAborted;
}], [function () {
  return true;
}, function () {
  return UnknownError;
}]]);
var DefaultError = function DefaultError(_ref) {
  var _ref$baseComponent = _ref.baseComponent,
      BaseComponent = _ref$baseComponent === void 0 ? Fragment : _ref$baseComponent,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? null : _ref$error,
      props = _objectWithoutProperties(_ref, ["baseComponent", "error"]);

  var ErrorComp = getErrorComponent(error);
  return createElement(BaseComponent, props, ErrorComp);
};

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n  min-height: 100px;\n  display: flex;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteral(["\n  margin: auto;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}
var messages$2 = defineMessages({
  slowConnectionOnLoading: {
    id: 'slowConnectionOnLoading',
    defaultMessage: 'This seems to take a very long time, maybe you currently have a bad internet connection?'
  }
});
var progress = css(_templateObject$4());
var loadingDiv = css(_templateObject2$2());
var progressDiv = css(_templateObject3());
var DefaultLoadableLoading = function DefaultLoadableLoading(_ref) {
  var _ref$withSlowConnecti = _ref.withSlowConnectionHint,
      withSlowConnectionHint = _ref$withSlowConnecti === void 0 ? false : _ref$withSlowConnecti;
  return React__default.createElement("div", {
    className: loadingDiv
  }, React__default.createElement("div", {
    className: progressDiv
  }, React__default.createElement(CircularProgress, {
    className: progress,
    size: 100
  }), withSlowConnectionHint && React__default.createElement(Typography, {
    align: "center"
  }, React__default.createElement(I18nMessage, {
    message: messages$2.slowConnectionOnLoading
  }))));
};

var LoadingContainer = function LoadingContainer(props) {
  if (props.error) {
    throw getErrorFromProp('unknown error in LoadingContainer', props.error);
  }

  if (props.isLoading || props.timedOut) {
    return React__default.createElement(DefaultLoadableLoading, {
      withSlowConnectionHint: props.timedOut
    });
  }

  return null;
};

function DefaultLoadable(_ref) {
  var _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? LoadingContainer : _ref$loading,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 200 : _ref$delay,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 10000 : _ref$timeout,
      loadableOpts = _objectWithoutProperties(_ref, ["loading", "delay", "timeout"]);

  return Loadable(_objectSpread({
    loading: loading,
    delay: delay,
    timeout: timeout
  }, loadableOpts));
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin: auto;\n  color: ", ";\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flexshrink: 0;\n  bordercolor: ", ";\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var iconBorder = function iconBorder(theme) {
  return css(_templateObject$5(), theme.palette.text.secondary);
};

var iconClass = function iconClass(theme) {
  return css(_templateObject2$3(), theme.palette.text.secondary);
};

var InnerIconWithBorder = function InnerIconWithBorder(_ref) {
  var theme = _ref.theme,
      icon = _ref.icon,
      _ref$iconPositionAdju = _ref.iconPositionAdjust,
      iconPositionAdjust = _ref$iconPositionAdju === void 0 ? '' : _ref$iconPositionAdju,
      _ref$borderStyle = _ref.borderStyle,
      borderStyle = _ref$borderStyle === void 0 ? 'solid' : _ref$borderStyle,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 2 : _ref$borderWidth,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? '' : _ref$borderColor,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? '' : _ref$iconColor,
      _ref$borderSize = _ref.borderSize,
      borderSize = _ref$borderSize === void 0 ? 56 : _ref$borderSize,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 56 : _ref$iconSize;
  var borderRadius = borderSize / 2 + borderWidth / 2;
  return React__default.createElement("div", {
    className: iconBorder(theme),
    style: {
      borderRadius: borderRadius,
      borderWidth: borderWidth,
      borderStyle: borderStyle,
      width: borderSize,
      height: borderSize,
      borderColor: borderColor
    }
  }, React__default.createElement("div", {
    className: iconClass(theme),
    style: {
      fontSize: iconSize,
      color: iconColor
    }
  }, React__default.createElement(FontAwesomeIcon, {
    icon: icon,
    transform: "".concat(iconPositionAdjust, " shrink-6")
  })));
};

var IconWithBorder = withTheme()(InnerIconWithBorder);

function _templateObject$6() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: #fff;\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var avatarClass = function avatarClass(theme) {
  return css(_templateObject$6(), theme.palette.primary.main);
};

// font size decides about icon size
var InnerIconWithCircleBackground = function InnerIconWithCircleBackground(_ref) {
  var theme = _ref.theme,
      icon = _ref.icon,
      _ref$iconPositionAdju = _ref.iconPositionAdjust,
      iconPositionAdjust = _ref$iconPositionAdju === void 0 ? '' : _ref$iconPositionAdju,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 64 : _ref$iconSize,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '' : _ref$backgroundColor,
      _ref$backgroundSize = _ref.backgroundSize,
      backgroundSize = _ref$backgroundSize === void 0 ? 64 : _ref$backgroundSize,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? '' : _ref$iconColor;
  return React__default.createElement("div", {
    style: {
      display: 'flex'
    }
  }, React__default.createElement(Avatar, {
    className: avatarClass(theme),
    style: {
      width: backgroundSize,
      height: backgroundSize,
      fontSize: iconSize,
      backgroundColor: backgroundColor,
      color: iconColor,
      margin: 'auto'
    }
  }, React__default.createElement(FontAwesomeIcon, {
    icon: icon,
    transform: "".concat(iconPositionAdjust, " shrink-4")
  })));
};

var IconWithCircleBackground = withTheme()(InnerIconWithCircleBackground);

function _templateObject$7() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var avatarClass$1 = function avatarClass(theme) {
  return css(_templateObject$7(), theme.palette.primary.main, theme.palette.primary.contrastText);
};

var InnerNumberIcon = function InnerNumberIcon(_ref) {
  var theme = _ref.theme,
      number = _ref.number,
      _ref$numberSize = _ref.numberSize,
      numberSize = _ref$numberSize === void 0 ? 40 : _ref$numberSize,
      _ref$backgroundSize = _ref.backgroundSize,
      backgroundSize = _ref$backgroundSize === void 0 ? 56 : _ref$backgroundSize,
      fontColor = _ref.fontColor,
      backgroundColor = _ref.backgroundColor,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? null : _ref$style,
      props = _objectWithoutProperties(_ref, ["theme", "number", "numberSize", "backgroundSize", "fontColor", "backgroundColor", "style"]);

  return React__default.createElement(Avatar, _extends({
    className: avatarClass$1(theme),
    style: _objectSpread({
      color: fontColor,
      backgroundColor: backgroundColor,
      height: backgroundSize,
      width: backgroundSize,
      fontSize: numberSize
    }, style)
  }, props), number);
};

var NumberIcon = withTheme()(InnerNumberIcon);

function _templateObject2$4() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: auto;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-shrink: 0;\n  margin: auto;\n  border-color: ", ";\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var iconBorder$1 = function iconBorder(theme) {
  return css(_templateObject$8(), theme.palette.text.secondary);
};

var stepClass = function stepClass(theme) {
  return css(_templateObject2$4(), theme.palette.text.secondary);
};

var InnerStepIcon = function InnerStepIcon(_ref) {
  var step = _ref.step,
      theme = _ref.theme,
      _ref$borderStyle = _ref.borderStyle,
      borderStyle = _ref$borderStyle === void 0 ? 'solid' : _ref$borderStyle,
      _ref$numberSize = _ref.numberSize,
      numberSize = _ref$numberSize === void 0 ? 30 : _ref$numberSize,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? 2 : _ref$borderWidth,
      borderColor = _ref.borderColor,
      iconColor = _ref.iconColor,
      _ref$borderSize = _ref.borderSize,
      borderSize = _ref$borderSize === void 0 ? 60 : _ref$borderSize;
  var borderRadius = Number(borderSize) / 2 + Number(borderWidth);
  return React__default.createElement("div", {
    className: iconBorder$1(theme),
    style: {
      borderRadius: borderRadius,
      border: borderWidth,
      borderStyle: borderStyle,
      width: borderSize,
      height: borderSize,
      borderColor: borderColor
    }
  }, React__default.createElement(Typography, {
    style: {
      color: iconColor,
      fontSize: numberSize
    },
    className: stepClass(theme),
    variant: "title"
  }, step));
};

var StepIcon = withTheme()(InnerStepIcon);

function _templateObject2$5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin: auto;\n  width: 50%;\n  border-bottom: 1px solid;\n  border-color: ", ";\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n  display: flex;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}
var orDivider = css(_templateObject$9());

var orDividerSpan = function orDividerSpan(theme) {
  return css(_templateObject2$5(), theme.palette.text.primary);
};

var InnerDividerWithMessage = function InnerDividerWithMessage(_ref) {
  var theme = _ref.theme,
      message = _ref.message;
  return React__default.createElement(Typography, {
    align: 'center'
  }, React__default.createElement("span", {
    className: orDivider
  }, React__default.createElement("span", {
    className: orDividerSpan(theme)
  }), React__default.createElement("span", {
    style: {
      padding: '0px 8px'
    }
  }, message), React__default.createElement("span", {
    className: orDividerSpan(theme)
  })));
};

var DividerWithMessage = withTheme()(InnerDividerWithMessage);

var GridContainer = function GridContainer(_ref) {
  var _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 16 : _ref$spacing,
      children = _ref.children,
      _ref$withNoScrollPadd = _ref.withNoScrollPaddingWorkaround,
      withNoScrollPaddingWorkaround = _ref$withNoScrollPadd === void 0 ? false : _ref$withNoScrollPadd,
      props = _objectWithoutProperties(_ref, ["spacing", "children", "withNoScrollPaddingWorkaround"]);

  return withNoScrollPaddingWorkaround ? React__default.createElement("div", {
    style: {
      padding: spacing / 2,
      width: '100%'
    }
  }, React__default.createElement(Grid, _extends({
    container: true,
    spacing: spacing
  }, props), children)) : React__default.createElement(Grid, _extends({
    container: true,
    spacing: spacing
  }, props), children);
};

function _templateObject2$6() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 8px;\n  font-size: 1rem;\n  line-height: 1.5em;\n  font-family: Roboto, Helvetica, Arial, sans-serif;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n      padding: 8px;\n      & > * {\n        color: inherit;\n      },\n    }"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}
/* eslint-disable react/no-array-index-key */

var listPointClass = function listPointClass(theme) {
  return css(_templateObject$a(), theme.palette.text.primary);
};

var font = css(_templateObject2$6());

var InnerListWithBulletPoints = function InnerListWithBulletPoints(_ref) {
  var theme = _ref.theme,
      listArray = _ref.listArray,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? faCircle : _ref$icon,
      _ref$iconFontSize = _ref.iconFontSize,
      iconFontSize = _ref$iconFontSize === void 0 ? '0.6rem' : _ref$iconFontSize,
      _ref$listItemTextClas = _ref.listItemTextClassName,
      listItemTextClassName = _ref$listItemTextClas === void 0 ? '' : _ref$listItemTextClas;
  return React__default.createElement(List, null, listArray && listArray.map(function (listPoint, index) {
    return React__default.createElement(ListItem, {
      key: index,
      style: {
        fontSize: iconFontSize
      },
      className: listPointClass(theme)
    }, React__default.createElement(ListItemIcon, null, React__default.createElement(FontAwesomeIcon, {
      icon: icon
    })), React__default.createElement(ListItemText, {
      primary: listPoint,
      className: cn(font, listItemTextClassName),
      disableTypography: true
    }));
  }));
};

var ListWithBulletPoints = withTheme()(InnerListWithBulletPoints);

function _templateObject2$7() {
  var data = _taggedTemplateLiteral(["\n  text-decoration: none;\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteral(["\n    padding: 8px 8px 8px 0px;\n    &> * {\n      color: inherit;\n    },\n  "]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}
/* eslint-disable react/no-array-index-key */

var listPointCss = css(_templateObject$b());
var font$1 = css(_templateObject2$7());
var UrlList = function UrlList(_ref) {
  var linkList = _ref.linkList;
  return React__default.createElement(List, null, linkList && linkList.map(function (listPoint, index) {
    return React__default.createElement(ListItem, {
      key: index,
      className: listPointCss
    }, React__default.createElement(Link, {
      to: listPoint.url,
      className: font$1
    }, React__default.createElement(ListItemText, {
      primary: listPoint.text
    })));
  }));
};

var Loading = function Loading(_ref) {
  var _ref$isSlowConnection = _ref.isSlowConnection,
      isSlowConnection = _ref$isSlowConnection === void 0 ? false : _ref$isSlowConnection,
      _ref$hasPastDelay = _ref.hasPastDelay,
      hasPastDelay = _ref$hasPastDelay === void 0 ? true : _ref$hasPastDelay;
  return hasPastDelay ? React__default.createElement(DefaultLoadableLoading, {
    withSlowConnectionHint: isSlowConnection
  }) : null;
};

function _templateObject$c() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var root = function root(theme) {
  return css(_templateObject$c(), theme.palette.primary.main);
};

var InnerPrimaryColorAvatar = function InnerPrimaryColorAvatar(_ref) {
  var className = _ref.className,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["className", "theme"]);

  return React__default.createElement(Avatar, _extends({
    className: cn(root(theme), className)
  }, props));
};

var PrimaryColorAvatar = withTheme()(InnerPrimaryColorAvatar);

var InnerShowComponentWhileLoading = function InnerShowComponentWhileLoading(_ref) {
  var isLoading = _ref.isLoading,
      _ref$loadingComponent = _ref.loadingComponent,
      LoadingComponent = _ref$loadingComponent === void 0 ? Loading : _ref$loadingComponent,
      _ref$errorComponent = _ref.errorComponent,
      ErrorComponent = _ref$errorComponent === void 0 ? DefaultError : _ref$errorComponent,
      _ref$error = _ref.error,
      error = _ref$error === void 0 ? null : _ref$error,
      _ref$hasPastDelay = _ref.hasPastDelay,
      _ref$isSlowConnection = _ref.isSlowConnection,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["isLoading", "loadingComponent", "errorComponent", "error", "hasPastDelay", "isSlowConnection", "children"]);

  if (isLoading) {
    return React__default.createElement(LoadingComponent, props);
  }

  if (!!error) {
    return React__default.createElement(ErrorComponent, props);
  } // typescript error: return has to be wrapped in JSX


  return React__default.createElement(React__default.Fragment, null, children);
};
var ShowComponentWhileLoading = addDelayToLoadingProp(200, 'isLoading', 'hasPastDelay')(addDelayToLoadingProp(6000, 'isLoading', 'isSlowConnection')(InnerShowComponentWhileLoading));

function _templateObject$d() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var redBg = function redBg(theme) {
  return css(_templateObject$d(), theme.palette.error.main);
};

var InnerSnackBarFailure = function InnerSnackBarFailure(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      open = _ref.open,
      props = _objectWithoutProperties(_ref, ["theme", "children", "open"]);

  return React__default.createElement(Snackbar, _extends({
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    autoHideDuration: 5000,
    TransitionComponent: Fade,
    ContentProps: {
      classes: {
        root: redBg(theme)
      }
    },
    message: children,
    open: open
  }, props));
};

var SnackBarFailure = withTheme()(InnerSnackBarFailure);

function _templateObject$e() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var greenBg = function greenBg(theme) {
  return css(_templateObject$e(), theme.palette.primary.main);
};

var InnerSnackBarSuccess = function InnerSnackBarSuccess(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      open = _ref.open,
      props = _objectWithoutProperties(_ref, ["theme", "children", "open"]);

  return React__default.createElement(Snackbar, _extends({
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'right'
    },
    autoHideDuration: 5000,
    TransitionComponent: Fade,
    ContentProps: {
      classes: {
        root: greenBg(theme)
      }
    },
    message: children,
    open: open
  }, props));
};

var SnackBarSuccess = withTheme()(InnerSnackBarSuccess);

function _templateObject$f() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var iconColorClass = function iconColorClass(theme) {
  return css(_templateObject$f(), theme.palette.text.primary);
};

var InnerIconWithTextInGrid = function InnerIconWithTextInGrid(_ref) {
  var theme = _ref.theme,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? null : _ref$icon,
      text = _ref.text,
      iconColor = _ref.iconColor,
      textColor = _ref.textColor;
  return React__default.createElement(Grid, {
    container: true
  }, React__default.createElement(Grid, {
    item: true,
    xs: 2,
    sm: 1,
    style: {
      display: 'flex'
    }
  }, icon && React__default.createElement("div", {
    className: iconColorClass(theme),
    style: {
      margin: 'auto',
      color: iconColor
    }
  }, React__default.createElement(FontAwesomeIcon, {
    icon: icon
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 10,
    sm: 11
  }, React__default.createElement(Typography, {
    style: {
      margin: 'auto 8px',
      color: textColor
    }
  }, text)));
};

var IconWithTextInGrid = withTheme()(InnerIconWithTextInGrid);

function _templateObject$g() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin: auto;\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var iconColorClass$1 = function iconColorClass(theme) {
  return css(_templateObject$g(), theme.palette.text.primary);
};

var InnerIconWithTextInGridWithExternalLink = function InnerIconWithTextInGridWithExternalLink(_ref) {
  var theme = _ref.theme,
      url = _ref.url,
      icon = _ref.icon,
      text = _ref.text,
      _ref$noBlankTarget = _ref.noBlankTarget,
      noBlankTarget = _ref$noBlankTarget === void 0 ? false : _ref$noBlankTarget;
  var urlObj = typeof url === 'string' ? new URL(url) : url;
  return React__default.createElement(Grid, {
    container: true
  }, React__default.createElement(Grid, {
    item: true,
    xs: 2,
    sm: 1,
    style: {
      display: 'flex'
    }
  }, React__default.createElement("div", {
    className: iconColorClass$1(theme)
  }, React__default.createElement(FontAwesomeIcon, {
    icon: icon
  }))), React__default.createElement(Grid, {
    item: true,
    xs: 10,
    sm: 11
  }, React__default.createElement("a", {
    target: noBlankTarget ? '' : '_blank',
    href: urlObj.href
  }, React__default.createElement(Typography, {
    style: {
      margin: 'auto 8px'
    }
  }, text))));
};

var IconWithTextInGridWithExternalLink = withTheme()(InnerIconWithTextInGridWithExternalLink);

var TextWithIconCaption = function TextWithIconCaption(_ref) {
  var icon = _ref.icon,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 16 : _ref$spacing,
      _ref$iconFontSize = _ref.iconFontSize,
      iconFontSize = _ref$iconFontSize === void 0 ? '2.2rem' : _ref$iconFontSize,
      _ref$captionMessage = _ref.captionMessage,
      captionMessage = _ref$captionMessage === void 0 ? null : _ref$captionMessage,
      _ref$caption = _ref.caption,
      caption = _ref$caption === void 0 ? null : _ref$caption,
      text = _ref.text,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ["icon", "spacing", "iconFontSize", "captionMessage", "caption", "text", "style"]);

  return React__default.createElement("div", _extends({
    style: _objectSpread({
      display: 'flex',
      width: '100%',
      height: '100%'
    }, style)
  }, props), React__default.createElement(FontAwesomeIcon, {
    fixedWidth: true,
    icon: icon,
    style: {
      margin: "auto ".concat(spacing / 2, "px"),
      fontSize: iconFontSize
    }
  }), React__default.createElement("div", {
    style: {
      margin: "auto ".concat(spacing / 2, "px")
    }
  }, React__default.createElement(Typography, {
    variant: "caption"
  }, captionMessage ? React__default.createElement(I18nMessage, {
    message: captionMessage
  }) : caption), React__default.createElement(Typography, null, text)));
};

function withIsWidthDown(breakPoint, key) {
  return compose(withWidth(), withPropOnChange(['width'], key, function (props) {
    return isWidthDown(breakPoint, props.width);
  }));
}

function _templateObject$h() {
  var data = _taggedTemplateLiteral(["\n  font-family: Lora, ", ";\n  color: ", ";\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

// default values by material-ui: https://material-ui-next.com/api/typography/#typography
var headlineMapping = function headlineMapping(isResponsiveXs) {
  return Object.create({
    display4: 'h1',
    display3: 'h1',
    display2: 'h1',
    display1: 'h1',
    headline: isResponsiveXs ? 'h1' : 'h2',
    // title: isResponsiveXs ? 'h2' : 'h3',
    subheading: isResponsiveXs ? 'h2' : 'h3',
    body2: isResponsiveXs ? 'h3' : 'p',
    body1: 'p'
  });
};

var responsiveMapping = cond([[equals('h1'), function () {
  return 'headline';
}], [equals('h2'), function () {
  return 'subheading';
}], [equals('h3'), function () {
  return 'body2';
}]]);
var commonMapping = cond([[equals('h1'), function () {
  return 'display2';
}], [equals('h2'), function () {
  return 'headline';
}], [equals('h3'), function () {
  return 'subheading';
}]]);

var headlineToType = function headlineToType(headlineType, responsive, isXs) {
  return isXs && responsive ? responsiveMapping(headlineType) : commonMapping(headlineType);
};

var mainHeadline = function mainHeadline(theme) {
  return css(_templateObject$h(), theme.typography.display3.fontFamily, theme.palette.primary.main);
};

var InnerHeadline = function InnerHeadline(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      _ref$responsive = _ref.responsive,
      responsive = _ref$responsive === void 0 ? false : _ref$responsive,
      _ref$isXs = _ref.isXs,
      isXs = _ref$isXs === void 0 ? false : _ref$isXs,
      headlineType = _ref.headlineType,
      props = _objectWithoutProperties(_ref, ["theme", "children", "responsive", "isXs", "headlineType"]);

  return React__default.createElement(Typography, _extends({
    variant: headlineToType(headlineType, responsive, isXs),
    headlineMapping: headlineMapping(responsive && isXs),
    className: headlineType === 'h1' && !isXs ? mainHeadline(theme) : ''
  }, props), children);
};

var InnerHeadline2 = withTheme()(InnerHeadline);
var Headline = withIsWidthDown('xs', 'isXs')(InnerHeadline2);

var HeadlineWithDivider = function HeadlineWithDivider(_ref) {
  var children = _ref.children,
      headlineType = _ref.headlineType,
      _ref$noRow = _ref.noRow,
      noRow = _ref$noRow === void 0 ? false : _ref$noRow,
      props = _objectWithoutProperties(_ref, ["children", "headlineType", "noRow"]);

  return React__default.createElement(Grid, {
    container: true
  }, React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, React__default.createElement(Headline, _extends({
    headlineType: headlineType
  }, props), children), noRow && React__default.createElement(Divider, null)), !noRow && React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, React__default.createElement(Divider, null)));
};

var withIsSm = function withIsSm(key) {
  return withIsWidthDown('sm', key);
};

export { AppMuiThemeDecorator, ShowComponentWhileLoading, DefaultError, UnknownError, Loading, DefaultLoadable, ConnectionAborted, CStepButton, TextWithIconCaption, PrimaryColorAvatar, withIsWidthDown, withIsSm, ButtonWithIcon, SavingButton, SavingIconButton, DividerWithMessage, GridRow, rowTypes, GridContainer, ListWithBulletPoints, UrlList, CustomTooltip, Headline, HeadlineWithDivider, IconWithBorder, IconWithCircleBackground, NumberIcon, StepIcon, IconWithTextInGrid, IconWithTextInGridWithExternalLink, SnackBarSuccess, SnackBarFailure };
//# sourceMappingURL=apoly-material-ui.esm.js.map
